module.exports = __webpack_public_path__ + "img/ces.dc0a38e0.png";